import React from 'react'
import PropTypes from 'prop-types'
import Styled from 'styled-components'

const DIRECTIONS = {
  width: "width",
  height: "height"
}

const SpacerContainer = Styled.div`
  ${props => props.$direction === DIRECTIONS.height && `height: ${props.$desktop}${props.$unit};`}
  ${props => props.$direction === DIRECTIONS.width && `width: ${props.$desktop}${props.$unit};`}
  transition: all 0.5s ease;
  ${props => props.theme.media.mobile`
    ${props.$direction === DIRECTIONS.height && `height: ${props.$mobile}${props.$unit};`}
    ${props.$direction === DIRECTIONS.width && `width: ${props.$mobile}${props.$unit};`}
  `};
    ${props => props.theme.media.smallDesktop`
    ${props.$direction === DIRECTIONS.height && `height: ${props.$mobile}${props.$unit};`}
    ${props.$direction === DIRECTIONS.width && `width: ${props.$mobile}${props.$unit};`}
  `};
`

const Spacer = ({ mobile, desktop, direction, unit }) => {
    return (
      <SpacerContainer
        $direction={direction}
        $unit={unit}
        $desktop={desktop}
        $mobile={mobile}
      />
)
}

Spacer.defaultProps = {
  mobile: 0,
  desktop: 0,
  direction: 'height',
  unit: 'px'
}

Spacer.propTypes = {
  mobile: PropTypes.number,
  desktop: PropTypes.number,
  direction: PropTypes.oneOf(Object.keys(DIRECTIONS)),
  unit: PropTypes.oneOf(['px', '%', 'em', 'rem'])
}

export default Spacer
